import { gql } from 'graphql-request'
import { useQuery, type UseQueryHookOptions } from '@/proxy/react-query'
import { client } from '@/proxy/client'

import type { SellerStatusData } from './types'

export const SELLER_STATUS = gql`
  query sellerStatus {
    seller {
      id
      shop {
        isOpen
        isTimeInsideWorking
      }
    }
  }
`

export const SELLER_STATUS_KEY = 'useSellerStatus'

export const useSellerStatus = (
  options?: UseQueryHookOptions<SellerStatusData>
) =>
  useQuery<SellerStatusData>({
    queryKey: [SELLER_STATUS_KEY],
    queryFn: variables => client.request(SELLER_STATUS, variables),
    ...options,
  })
